var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{attrs:{"title":"Проверка слейва","back":""}}),_c('get-info-slave')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }